import { render } from "./BlogLastMinuteGiftsView.vue?vue&type=template&id=b58d51a6"
import script from "./BlogLastMinuteGiftsView.vue?vue&type=script&lang=js"
export * from "./BlogLastMinuteGiftsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__